import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ScrollPositionService} from '../../services/scroll-position.service';
import {Callback} from '../../models/callback';
import {CallbackService} from '../../services/callback.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, AfterViewInit {
  callback: Callback = new Callback();
  submitted = false;
  sendButtonText = 'Send';

  constructor(private spService: ScrollPositionService,
              private callbackService: CallbackService) {
    this.callback.preferredHour = null;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.spService.autoScroll();
  }

  onSubmit() {
    console.log(this.callback);
    if (
      this.callback.name
      && this.callback.email
      && this.callback.company
      && this.callback.phone
      && this.callback.preferredHour
    ) {
      console.log('Valid');
      this.sendButtonText = 'Sending';
      this.callbackService.sendCallback(this.callback).subscribe(() => {
        this.sendButtonText = 'Send';
        this.submitted = true;
      });
    } else {
      console.log('Invalid');
    }
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/contact/contact.component.ts